<h3 mat-dialog-title *ngIf="data.title" id="{{data.id}}Title">{{ data.title }}</h3>
<mat-dialog-content >
  <div  id="{{data.id}}Content" [innerHTML]="data.body | safeHtml:'html' " ></div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-raised-button id="orderconfirmation_ok" class="nsc-button"  type="button" color="primary" (click)="close()">
    {{confirmMessage}}
   </button>
</mat-dialog-actions>
